import { RouteConfig } from 'vue-router'
import VueI18n from 'vue-i18n'
import DashboardView from '../views/DashboardView.vue'

const routes: (i18n: VueI18n) => Array<RouteConfig> = i18n => ([
  {
    path: '/tbord',
    name: 'home',
    component: DashboardView,
    meta: {
      pageHeader: false,
      title: i18n.t('dashboard.pageTitle'),
      appClass: {
        'dashboard-page': true
      }
    }
  },
])

export default routes
